import ko from '@tko/build.knockout';
import Vue from 'vue';
import Vuetify from '../../../../plugins/vuetify';
import templateMarkup from 'raw-loader!./dataset-view.template.html';
import VueDatasetView from '../../../../vueComponents/datasetView/src/datasetView.vue';

class DatasetView {
    constructor(params) {
        this.initialize(params);
    }

    initialize(params) {
      const self = this;
      this.routeObservable = params.routeParams || params.route;
      this.routeParams = ko.unwrap(params.routeParams || params.route());
      this.vueDatasetView = new Vue({
        el: '#vueDatasetViewHook',
        vuetify: Vuetify,
        data: {
          routeParams: this.routeParams,
        },
        render(h) {
          return h('section', { attrs: { id: 'vueDatasetView' } }, [
            h('v-app', { attrs: { id: 'dataset' } }, [
              h(VueDatasetView, { props: { routeParams: this.routeParams } })
            ])
          ]);
        }
      });

      this.routeSubscription = this.routeObservable.subscribe(function(route) {
        // this gets called before dispose so check to make sure the route is a dataset route
        if (route.view === 'historical2-dataset') {
          self.vueDatasetView.routeParams = route;
        }
      });

    }
    dispose() {
      if (this.routeSubscription) {
        this.routeSubscription.dispose();
      }
      if (this.vueDatasetView) {
        this.vueDatasetView.$destroy();
      }
    }
}


// this component is directly registered at 'src/app/component-registration.js'
// since it is needed long before its parent module is loaded
export default { template: templateMarkup, viewModel: DatasetView };
